import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { NullableString } from "@models/app.models";
import { ApiResponse } from "@models/responses/api-response.model";
import { EnvironmentService } from "@services/environment-service/environment.service";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class DohopService {
  private static readonly CONTROLLER_ROOT = 'v1/dohop';

  constructor(private httpClient: HttpClient) {}

  getPickerStations(
    payload: {
      prefix: string;
      origin: NullableString;
    },
  ): Observable<ApiResponse<string[]>> {
    const endpoint = `${EnvironmentService.environment.apiBaseUrl}${DohopService.CONTROLLER_ROOT}/picker`;
    return this.httpClient.post<ApiResponse<string[]>>(endpoint, payload);
  }
}
